import { Button, Row } from "@components/atoms";
import { TutorialGauge } from "@components/organisms";
import { Colors } from "@utils";
import { ComponentProps } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const BG = styled.div`
  background: linear-gradient(
    180deg,
    rgba(90, 221, 197, 0.148) 0%,
    rgba(90, 221, 197, 0) 100%
  );
`;

interface TutorialTemplateProps extends ComponentProps<"div"> {
  page: number;
}

const MAX_PAGE = 3;

const TutorialTemplate: React.FC<TutorialTemplateProps> = ({
  page,
  children,
  ...rest
}) => {
  const navigate = useNavigate();

  const gotoNextPage = () => {
    if (page < MAX_PAGE) {
      navigate(`/tutorial/${page + 1}`);
    } else {
      navigate("/agree");
    }
  };

  return (
    <div className="flex flex-col min-h-full" {...rest}>
      <div
        className="text-[15px]/[20px] font-[500] p-[22px] pb-[13px] whitespace-pre-wrap"
        style={{ color: Colors.darkGray, background: Colors.lightGreen }}
      >
        건강성적표는 고객님의 건강검진 기록을 토대로{"\n"}건강 정도를 성적표
        형태로 분석해드립니다.
      </div>
      <BG className="flex grow flex-col py-[22px] pt-[0px]">
        <div className="flex grow">{children}</div>
        <Row className="px-[22px]">
          <div className="grow mr-[20px]">
            <TutorialGauge page={page} maxPage={MAX_PAGE} />
          </div>
          <Button
            bgColor={Colors.primaryGreen}
            color={Colors.white}
            onClick={gotoNextPage}
            style={{
              width: "71px",
              height: "36px",
            }}
          >
            다음
          </Button>
        </Row>
      </BG>
    </div>
  );
};

export default TutorialTemplate;
